import { Guid } from "@/Common/Models/Guid";

class OffendingAgent {
    public Active: boolean;

    public Id: Guid;
    public CodeGen: string;
    public OffendingAgentName: string;
    public ActiveIngredientName: string;
}

export { OffendingAgent };
